import type React from "react";

import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Chip, IconButton } from "@mui/material";
import { useTheme } from "styled-components";

interface Props {
  readonly label: string;
  readonly close: () => void;
}

export const FilterTag: React.FC<Props> = ({ label, close }) => {
  const theme = useTheme();
  return (
    <Chip
      key={label}
      label={label}
      style={{ background: theme.colors.redesign.b10 }}
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onDelete={() => {}}
      deleteIcon={
        <IconButton
          onMouseUp={() => {
            close();
          }}
          size="small"
        >
          <FontAwesomeIcon icon={faTimes} size="xs" />
        </IconButton>
      }
    />
  );
};
